import styled from 'styled-components';
import { Trans } from '@lingui/react';
import Accordion from '@components/Accordion';
import Tag from '@components/Tag';
import { Flex } from '@components/layout/Grid';
import { NewTaxonomyItemFieldsFragment, Term } from '@gql/generated';
import Icon from '@components/Icon';

const TaxonomyGroupContainer = styled.div`
  flex: 1;
  padding-right: 20px;

  & + & {
    padding-left: 20px;
    border-left: 1px solid rgb(231, 231, 231);
  }
`;

const TaxonomiesBody = styled(Flex)`
  border-left: 1px solid rgba(213, 229, 238, 1);
  border-right: 1px solid rgba(213, 229, 238, 1);
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
`;

const CloseButton = styled.button`
  color: rgb(36, 36, 36);
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  border: none;
  padding: 8px 14px;
  background-color: rgb(213, 229, 238);
  cursor: pointer;
`;

const TaxonomyGroupLabel = styled.label`
  display: block;
  color: rgba(21, 21, 21, 1);
  font-size: 12px;
  font-weight: 600;
  line-height: 15px;
  text-transform: uppercase;
  padding-bottom: 10px;
  opacity: 0.6;

  &:empty {
    display: none;
  }
`;

const TaxonomyGroupList = styled(Flex)`
  gap: 8px;
`;

export const TaxonomyGroup = ({
  className = '',
  title,
  terms,
  slug,
  onSelectTerm,
  selectedTerms,
}) => {
  return (
    <TaxonomyGroupContainer className={className}>
      {title ? <TaxonomyGroupLabel>{title}</TaxonomyGroupLabel> : null}
      <TaxonomyGroupList flexWrap="wrap">
        {terms.map((term) => {
          return (
            <Tag
              key={term.slug}
              important={term.important}
              isSelected={(selectedTerms || []).includes?.(term.slug)}
              onClick={() => {
                onSelectTerm(term, slug);
              }}
            >
              {term.name}
            </Tag>
          );
        })}
      </TaxonomyGroupList>
    </TaxonomyGroupContainer>
  );
};

type Props = {
  taxonomy: NewTaxonomyItemFieldsFragment;
  selectedTerms: Record<string, string[]>;
  onSelectTerm(term: Term): void;
  selectedTaxonomySlug: string;
  onClose(): void;
};
export const TaxonomyTermsList = (props: Props) => {
  const { taxonomy } = props;

  let content = null;
  if (taxonomy?.subcategories?.length > 0) {
    content = taxonomy.subcategories?.map((sub) => {
      return (
        <TaxonomyGroup
          key={sub.slug}
          title={
            sub.name ? (
              <Trans
                id="videos_genres.taxonomy_subcategory.title"
                values={{ title: sub.name }}
              />
            ) : (
              ''
            )
          }
          terms={sub.terms}
          slug={taxonomy.slug}
          onSelectTerm={props.onSelectTerm}
          selectedTerms={props.selectedTerms?.[taxonomy?.slug]}
        />
      );
    });
  } else if (taxonomy?.nonSubcategorized) {
    content = (
      <NonSubcategorizedTaxonomyGroup
        key={taxonomy.slug}
        terms={taxonomy.nonSubcategorized}
        slug={taxonomy.slug}
        onSelectTerm={props.onSelectTerm}
        selectedTerms={props.selectedTerms?.[taxonomy?.slug]}
      />
    );
  }
  return (
    <Accordion
      isOpen={true}
      head=""
      body={
        taxonomy ? (
          <TaxonomiesBody flexDirection="column">
            <Flex px={20} py={30}>
              {content}
            </Flex>
            <CloseButton onClick={props.onClose}>
              <Icon />
              <Trans
                id="videos_genres.taxonomy_close_btn"
                message="Close filters"
              />
            </CloseButton>
          </TaxonomiesBody>
        ) : null
      }
    />
  );
};

const NonSubcategorizedTaxonomyGroup = ({
  className = '',
  terms,
  slug,
  onSelectTerm,
  selectedTerms,
}) => {
  let groupCount = Math.floor(terms.length / 3);

  const _terms = [...terms];
  const groups =
    terms.length > 20 && !['needs'].includes(slug)
      ? [_terms.splice(0, groupCount), _terms.splice(0, groupCount), _terms]
      : [_terms];

  return (
    <>
      {groups.map((group, i) => (
        <TaxonomyGroup
          className={className}
          key={i}
          title={''}
          terms={group}
          slug={slug}
          onSelectTerm={onSelectTerm}
          selectedTerms={selectedTerms}
        />
      ))}
    </>
  );
};
